import React, {FC} from 'react';
import classNames from 'classnames';
import DynamicAsset from 'components/DynamicAsset';
import {navigate} from 'gatsby';

import * as styles from './styles.module.scss';

export interface IImagePanelProps {
    imageTitle: string;
    imageSrc: string;
	link?: string;
}

const ImagePanel: FC<IImagePanelProps> = ({imageTitle, imageSrc, link}) => {
	function handleClick(): void {
		if (link) {
			navigate(link);
		}
	}

	return (
		<div className={classNames(styles.imagePanel, 'd-flex flex-column', link && 'cursor-pointer')} onClick={handleClick}>
			<DynamicAsset imageSrc={imageSrc} alt={imageTitle} className={classNames(styles.image, 'img-fluid')} />
			<div className={styles.title}>{imageTitle}</div>
		</div>
	);
};

export default ImagePanel;
